// Exports
export default {
	"selfSharingControlsLayer": "selfSharingControlsLayer_vcWvD"
};
